__turbopack_context__.v({
  "header": "header-module-scss-module__ME5lHG__header",
  "main-nav": "header-module-scss-module__ME5lHG__main-nav",
});
